export enum StopTypeType {
  Processed = 'processed',
  Open = 'open',
  Planned = 'planned',
}

export type StopType = {
  type: StopTypeType.Processed | StopTypeType.Open | StopTypeType.Planned;
  customerRef: string;
  stopNumber: number;
};
